const name = "Toufiq Hasan Kiron"

export const config = {
  name,
  slogan: "Full Stack Developer, Obsessed with Code",
  description:
    "Full-stack developer passionate about crafting elegant solutions and bringing ideas to life through code. Obsessed with building scalable applications, writing clean code, and creating exceptional user experiences that make a difference.",
  shortDescription:
    "Full Stack Developer, who focuses on clean code and scalable applications.",
  keywords: [
    "Full Stack Developer",
    "React",
    "Node.js",
    "TypeScript",
    "GraphQL",
    "Next.js",
    "Tailwind CSS",
    "MongoDB",
    "Firebase",
    "Cloudinary",
    "Vercel",
    "Heroku",
    "Netlify",
    "Obsessed with Code",
    "Coffee",
    "Travel",
  ],
  author: {
    name: "Toufiq Hasan Kiron",
    position: "Full Stack Developer",
    location: {
      full: "Dhaka, Bangladesh",
      short: "Dhaka",
    },
  },
  url: "https://x.kiron.dev",
  ogImage: "/og.png",
}
